
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/modernization/done",
      function () {
        return require("private-next-pages/download/modernization/done/index.tsx");
      }
    ]);
  